<template>
  <div>
    <!-- <b-alert show variant="danger" v-if="error" dismissible>{{ $t('error.try-again') }}</b-alert> -->
    <div v-if="!initial">
      <span v-if="success">
        {{ $t('account-reenable-success') }}<br>
        <router-link tag="a" to="/inicio-sesion">{{ $helpers.getV2AppUrl('inicio-sesion') }}</router-link>

      </span>
      <span v-if="error">
        {{ $t('account-reenable-fail') }} <br>
        <router-link to="/inicio-sesion" tag="a">{{ $helpers.getV2AppUrl('inicio-sesion') }}</router-link>
        <!-- <div class="mt-3">
          <b-form-input type="text" v-model="email" placeholder="Email" :state="emailValidation"></b-form-input>
          <b-form-invalid-feedback>
            {{ $t('login.errors.email') }}
          </b-form-invalid-feedback>
        </div> -->
        <!-- <b-button variant="primary" @click="resendEnableAccountEmail" class="mt-4 w-100">{{ $t('send') }}</b-button>-->
      </span>
    </div>
    <div v-else>
      {{ $t('resend-account-enable-email-success', { email: email }) }}
    </div>
  </div>
</template>

<script>
import { BInputGroup, BFormInput, BInputGroupAppend, BFormInvalidFeedback, BButton } from 'bootstrap-vue'
import AccountRepository from '@/repositories/AccountRepository'

export default {
  components: {
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BFormInvalidFeedback,
    BButton
  },
  data () {
    return {
      success: false,
      initial: true,
      error: null,
      submitted: false
    }
  },
  async mounted () {
    if (!this.$route.query.token && this.$route.query.email) {
      // this is done by server side
      /* this.resendEnableAccountEmail() */
    } else {
      this.initial = false
      await AccountRepository.reenableAccount(this.$route.query.token).then((response) => {
        this.success = response.data
        if (!response.data || response.status !== 200) {
          this.error = 'reenable-user'
          this.success = false
        } else {
          this.error = null
        }
      })
    }
  },
  methods: {
    resendEnableAccountEmail () {
      this.submitted = true
      if (this.emailValidation !== false) {
        this.$api.get('Cognito/ResendEnableUserEmail', {
          params: {
            email: this.email
          }
        }).then((response) => {
          if (response.data.data) {
            this.initial = false
            this.error = null
          } else {
            this.error = 'resend-enable-user'
          }
        })
      }
    }
  },
  computed: {
    token: function () {
      return this.$route.query.token
    },
    email () {
      return this.$route.query.email ? this.$route.query.email.replace(' ', '+') : null
    },
    emailValidation: function () {
      return this.$validators.validate(this.email, ['required', 'email'], this.submitted)
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/public/account/ReenableAccount.vue